import {
  getProductsPending, getProductsSuccess, getProductsError,
} from '../actions/product';

import {ProductService} from '../../lib/qc-api-client';

export function getProducts(userId) {
  return dispatch => {
    dispatch(getProductsPending());
    ProductService.getProductsByUser(userId).then(response => {
      dispatch(getProductsSuccess({
        products:       response.data.products
      }));
    }).catch(error => {
      console.error(error)
      dispatch(getProductsError(error));
    })
  }
}
